// @flow
/* eslint max-len: 0 */
// eslint-disable-next-line no-useless-escape
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>`~\-_=+\\[\];'\/])[A-Za-z\d!@#$%^&*(),.?":{}|<>`~\-_=+\\[\];'\/ ]{8,20}$/;

export default PASSWORD_REGEX;